import { Grid, Paper, Typography } from "@material-ui/core";
import React from "react";

const BoxAllesKönner = (props) => {
  let { ModelID, Aanwezig } = props.data;

  ModelID = Number(ModelID);

  function borderColor() {
    if (Aanwezig === "1") {
      return "green 10px solid";
    } else {
      return "red 10px solid";
    }
  }

  return (
    <Paper
      elevation={2}
      style={{
        cursor: "pointer",
        border: borderColor(),
      }}
      onClick={() =>
        (window.location.href = `/media/AllesK%C3%B6nnerPDF/${String(
          ModelID
        ).padStart(3, "0")}-Unimog-Bau.pdf`)
      }
    >
      <Grid item xs={12} container justify="center" alignItems="center">
        <Typography noWrap style={{ fontSize: "200%" }}>
          {"AUSGABE " + ModelID}
        </Typography>
      </Grid>
    </Paper>
  );
};

export default BoxAllesKönner;
